/**
 * Login Button Component
 *
 * Initiates the OAuth2 login flow when clicked.
 */

import { type ReactElement } from 'react';
import { useAuth } from '../hooks/useAuth';

interface LoginButtonProps {
  className?: string;
}

export function LoginButton({ className }: LoginButtonProps): ReactElement {
  const { login, isLoading } = useAuth();

  const handleLogin = (): void => {
    void login();
  };

  return (
    <button
      onClick={handleLogin}
      disabled={isLoading}
      className={className}
      type="button"
    >
      {isLoading ? 'Redirecting...' : 'Sign In'}
    </button>
  );
}
